import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import config from './config'

const app = createApp(App)

app.use(ElementPlus)
app.use(router)
// 将配置对象挂载到app的全局属性上
app.config.globalProperties.$config = config

app.mount('#app') 